<div
  [class.overflow-auto]="overflow()"
  class="bg-base-100 max-h-80 z-20 flex flex-col py-2 rounded-md shadow-md min-w-max border border-gray-200">
  <ng-content />
</div>
